// extracted by mini-css-extract-plugin
export default {"-large":"GNeqpCLlSnxAHG9qpeJ1","container":"q5XffJ3G63k5oTouGBmW","selected":"QMzQkjTZrZfw3bQOwVlP","svgContainer":"ydbyDqHRAg5e74jdHXQK","blockAnimation":"h5rQUHSxz2QtaUeuOBrt"};